import {SzBox} from "@suezenv/react-theme-components";
import React from "react";
import {withTranslation} from "react-i18next";
import {connect} from "react-redux";
import {getContractId} from "../../main/utils";
import {servicesCodes} from "../../user/store/constants";
import ContactForm from "../forms/ContactForm";
import ContactService from "../services/ContactService";
import ReferentialService from "../services/ReferentialService";
import {projectReferentialAction} from "../store/actions";
import contactAction from "../store/actions/contactAction";

class EditContactManager extends React.Component<any> {

    public setReferential() {
        const contractId = getContractId(this.props.user);
        this.setState({contractId});
        // if dont have service project management
        if ("" === contractId) {
            return this.props.history.push("/");
        }

        this.initProjectContactTypes(contractId);
    }

    public componentDidUpdate(prevProps: any): void {
        const {user, contact} = this.props;

        const contractId = getContractId(user);
        if (!contractId ) {
            this.setReferential();
        }
        if (!contact) {
            this.init();
        }
    }

    public componentDidMount(): void {
        if (this.props.user.services[servicesCodes.projectManagement] && this.props.user.services[servicesCodes.projectManagement].length) {
            this.setReferential();
            this.init();
        }
    }

    private init() {
        const { idContact, user, setContactDetail } = this.props;
        const contractId = getContractId(user);
        if (contractId) {
            ContactService.getContact(contractId, idContact).then((response) => {
                setContactDetail( response.data);
            });
        }
    }

    public initProjectContactTypes(contractId: string) {
        if (this.props.projectReferential.contactTypes.length === 0) {
            ReferentialService.getContactTypes(contractId).then((data) => {
                this.props.setContactTypes(data);
            });
        }
    }

    public render(): any {
        const {t, projectReferential, user, contact} = this.props;
        const contractId = getContractId(user);
        return (
            <>
                {contractId && (
                    <>
                        <div className="m-2 bg-white w-100 new-contact-title">
                            <div
                                className="sz-card-collapse__header sz-left-border position-relative align-items-center m-0 row">
                                <div className="w-100 col-md-6 col-sm-12">
                                    <SzBox className="justify-content-around pb-0">
                                        <label className="mb-0 font-weight-bold">{t("contact.edit_contact_title")}</label>
                                    </SzBox>
                                </div>
                            </div>
                        </div>
                        <div className="contact-form w-100 bg-white justify-center">

                            <ContactForm
                                contractId={contractId}
                                contactTypes={projectReferential.contactTypes}
                                contactData={contact}
                                saveAction={(payload: any) => {}}
                                redirect={true}
                            />
                        </div>

                    </>
                )}
            </>
        );
    }
}

const mapDispatchToProps = {
    setContactTypes: projectReferentialAction.setContactTypes,
    setContactDetail: contactAction.setContactDetail,
};
const mapStateToProps = (state: any) => {
    return {
        user: state.user,
        projectReferential: state.projectReferential,
        contact: state.contact.contactDetail,
    };
};
export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withTranslation()(EditContactManager));
